import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareD = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler4') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler4', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Chaos ely pet!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Chaos ely pet!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareD}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareD